import { EventEmitter, Directive, ElementRef, ChangeDetectorRef, Input, Output, HostBinding, HostListener, Component, NgZone, ViewChild, ViewChildren, Pipe, NgModule } from '@angular/core';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subject, of, Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';

function CompleterComponent_span_3_ng_container_1_1_ng_template_0_Template(rf, ctx) { }
function CompleterComponent_span_3_ng_container_1_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CompleterComponent_span_3_ng_container_1_1_ng_template_0_Template, 0, 0, "ng-template");
} }
const _c0 = function (a0) { return { $implicit: a0 }; };
function CompleterComponent_span_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CompleterComponent_span_3_ng_container_1_1_Template, 1, 0, undefined, 13);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.group.placeholderValue)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c0, ctx_r5._DOM.placeholder));
} }
function CompleterComponent_span_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6._DOM.placeholder.title, " ");
} }
function CompleterComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtemplate(1, CompleterComponent_span_3_ng_container_1_Template, 2, 4, "ng-container", 11);
    ɵngcc0.ɵɵtemplate(2, CompleterComponent_span_3_ng_template_2_Template, 1, 1, "ng-template", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.group.placeholderValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.group.placeholderValue);
} }
function CompleterComponent_div_8_ng_container_1_1_ng_template_0_Template(rf, ctx) { }
function CompleterComponent_div_8_ng_container_1_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CompleterComponent_div_8_ng_container_1_1_ng_template_0_Template, 0, 0, "ng-template");
} }
function CompleterComponent_div_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CompleterComponent_div_8_ng_container_1_1_Template, 1, 0, undefined, 13);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r9.group.noResults)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c0, ctx_r9._completer));
} }
function CompleterComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, CompleterComponent_div_8_ng_container_1_Template, 2, 4, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.group.noResults);
} }
function CompleterComponent_div_9_ng_container_1_1_ng_template_0_Template(rf, ctx) { }
function CompleterComponent_div_9_ng_container_1_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CompleterComponent_div_9_ng_container_1_1_ng_template_0_Template, 0, 0, "ng-template");
} }
const _c1 = function (a0, a1) { return { $implicit: a0, highlight: a1 }; };
function CompleterComponent_div_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CompleterComponent_div_9_ng_container_1_1_Template, 1, 0, undefined, 13);
    ɵngcc0.ɵɵpipe(2, "highlight");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r12 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r14.group.dropdownValue)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(5, _c1, ctx_r14._items[item_r12], ɵngcc0.ɵɵpipeBind2(2, 2, ctx_r14._items[item_r12].title, ctx_r14._highlight)));
} }
function CompleterComponent_div_9_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 17);
    ɵngcc0.ɵɵpipe(1, "highlight");
} if (rf & 2) {
    const item_r12 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(1, 1, ctx_r15._items[item_r12].title, ctx_r15._highlight), ɵngcc0.ɵɵsanitizeHtml);
} }
function CompleterComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵlistener("click", function CompleterComponent_div_9_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r21); const item_r12 = restoredCtx.$implicit; const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.SelectItem(ctx_r20._items[item_r12]); });
    ɵngcc0.ɵɵtemplate(1, CompleterComponent_div_9_ng_container_1_Template, 3, 8, "ng-container", 11);
    ɵngcc0.ɵɵtemplate(2, CompleterComponent_div_9_div_2_Template, 2, 4, "div", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r4._items[item_r12].className);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.group.dropdownValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.group.dropdownValue);
} }
const _c2 = function (a0, a1, a2) { return { "open": a0, "is-loading": a1, "is-async": a2 }; };
const _c3 = function (a0) { return { "completion-off": a0 }; };
const _c4 = function (a0) { return { "open": a0 }; };
const _c5 = function (a0) { return { "is-initial-empty": a0 }; };
const _c6 = ["init"];
function NgAutoCompleteComponent_ng_completer_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ng-completer", 4);
    ɵngcc0.ɵɵlistener("cleared", function NgAutoCompleteComponent_ng_completer_3_Template_ng_completer_cleared_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.InputCleared($event); })("no-result", function NgAutoCompleteComponent_ng_completer_3_Template_ng_completer_no_result_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.NoResult($event); })("selected", function NgAutoCompleteComponent_ng_completer_3_Template_ng_completer_selected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.ListenToSelected($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.classes)("group", item_r2);
} }
class AutocompleteItem {
    constructor(title, id, className, original) {
        this.title = title;
        this.id = id;
        this.className = className;
        this.original = original;
    }
}
/**
 *
 */
function SearchableAutoCompleteItems(items, titleKey, childrenKey = null) {
    return items.reduce(function (r, i) {
        const t = SearchableAutoCompleteString(i[titleKey], i.id);
        if (typeof r[t] === 'undefined') {
            r[t] = TransformToAutocompleteItem(i, titleKey, childrenKey);
        }
        return r;
    }, {});
}
/**
 *
 */
function SearchableAutoCompleteString(key, id) {
    return `${key.replace(/ /g, '_')}_id_${String(id)}`;
}
/**
 *
 */
function ComparableAutoCompleteString(str) {
    return str.replace(/_/g, ' ');
}
/**
 * object must have an ID
 */
function TransformToAutocompleteItem(object, titleKey, childrenKey = null) {
    const item = new AutocompleteItem(object[titleKey], object.id, object.className, object);
    /**
     * if there are children, add these.
     */
    if (childrenKey !== null) {
        item.children = object[childrenKey];
    }
    return item;
}

class AutocompleteGroup {
    constructor() {
        this.async = null;
        this.removals = [];
    }
    /**
     *
     */
    SetNewValue(value, titleKey) {
        const values = SearchableAutoCompleteItems(value, titleKey);
        this.SetCopy(values);
        /**
         *
         */
        this.value = this.FilterRemovals(this.removals, values);
    }
    /**
     *
     */
    Removables(ids) {
        this.removals = ids;
        /**
         *
         */
        this.value = this.FilterRemovals(this.removals, this._copy);
    }
    /**
     *
     */
    InitialValue() {
        this.value = this.FilterRemovals(this.removals, this.initialValue);
        /**
         *
         */
        this.SetCopy(this.initialValue);
    }
    /**
     *
     */
    SetCopy(values) {
        this._copy = Object.assign([], values);
    }
    /**
     *
     */
    SetValues(value) {
        this.value = SearchableAutoCompleteItems(value, this.keys.titleKey, this.keys.childrenKey);
        /**
         *
         */
        this.initialValue = Object.assign({}, this.value);
        this.SetCopy(Object.assign({}, this.value));
    }
    /**
     *
     */
    FilterRemovals(removals, value) {
        let filtered = Object.assign({}, value);
        let key, keys = [];
        for (key in filtered) {
            if (filtered.hasOwnProperty(key)) {
                removals.forEach((id) => {
                    // Comparable string and ID
                    let f = `_id_${String(id)}`;
                    let c = key.substring(key.indexOf(f), key.length);
                    if (f === c) {
                        keys.push(key);
                    }
                });
            }
        }
        keys.forEach((k) => {
            delete filtered[k];
        });
        return filtered;
    }
}
/**
 *
 */
function CreateNewAutocompleteGroup(placeholder, key, value, keys, parent = '', completion = true, searchLength = 2) {
    const group = new AutocompleteGroup();
    group.key = key;
    group.keys = keys;
    group.placeholder = placeholder;
    group.parent = parent;
    group.completion = completion;
    group.searchLength = searchLength;
    /**
     * Initial value needed, if we empty search box or want to clear it, it needs to be reset.
     * Setting copy, used if user wants to remove values (by id.). This _ list gets filtered.
     */
    group.SetValues(value);
    return group;
}

const UsedCodeList = {
    ArrowDown: 40,
    ArrowUp: 38,
    Enter: 13,
    Escape: 27,
    Tab: 9,
    MetaLeft: 91,
    AltLeft: 18,
    ControlLeft: 17,
    ShiftLeft: 16,
    ArrowLeft: 37,
    ArrowRight: 39,
    MetaRight: 93,
    AltRight: 18
};
/**
 *
 */
function ReturnStringArrayByID(array) {
    return array.reduce((result, item) => {
        result.push(item.id.toString());
        return result;
    }, []);
}
/**
 *
 */
function FilterRemovals(removals, list) {
    return list.filter((item) => {
        return removals.indexOf(item.id.toString()) <= -1;
    });
}
/**
 *
 */
function IsMobileOrTablet() {
    let isMobile = false;
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
        isMobile = true;
    }
    return isMobile;
}
function NotUsedKey(code) {
    return typeof UsedCodeList[code] === 'undefined';
}

class NgDropdownDirective {
    constructor(_eref, cdr) {
        this._eref = _eref;
        this.cdr = cdr;
        this.list = [];
        this.active = null;
        this.input = null;
        this.element = null;
        this.key = '';
        this.completion = true;
        this.hover = new EventEmitter();
        this.selected = new EventEmitter();
        this.closed = new EventEmitter();
        this._open = false;
        this._list = [];
        this._class = '';
        this.inputKeydownBind = this.inputKeydown.bind(this);
        this.mouseoverListenerBind = this.mouseoverListener.bind(this);
        this.documentKeydownBind = this.documentKeydown.bind(this);
    }
    /**
     *
     */
    ngOnInit() {
        this._class = `dr-item-${this.key}-`;
        if (!IsMobileOrTablet()) {
            this._eref.nativeElement.addEventListener('mouseover', this.mouseoverListenerBind);
        }
        /**
         *
         */
        this.PrepareList();
    }
    /**
     *
     */
    ngOnChanges(changes) {
        if (typeof changes['active'] !== 'undefined' && !changes['active'].firstChange) {
            this.PrepareList();
        }
        if (typeof changes['list'] !== 'undefined') {
            this.list = changes['list'].currentValue;
            /**
             *
             */
            this.PrepareList();
        }
    }
    /**
     *
     */
    keyDown(event) {
        event.stopImmediatePropagation();
        event.stopPropagation();
        /**
         *
         */
        switch (event.code) {
            case 'ArrowDown':
                this.Open();
                /**
                 *
                 */
                this.SetActive(this.FindActive() + 1);
                this.DropdownFocusAreaDown();
                event.preventDefault();
                break;
            case 'ArrowUp':
                this.Open();
                /**
                 *
                 */
                this.SetActive(this.FindActive() - 1);
                this.DropdownFocusAreaUp();
                event.preventDefault();
                break;
            case 'Enter':
                this.EmitSelected();
                this.Close(null, true);
                if (this.RefExists()) {
                    this.input.blur();
                }
                event.preventDefault();
                break;
            case 'Escape':
                this.Close(null, true);
                if (this.RefExists()) {
                    this.input.blur();
                }
                event.preventDefault();
                break;
            case 'Tab':
                if (!event.shiftKey) {
                    this.EmitSelected();
                }
                this.Close(null, true);
                break;
            default:
                return;
        }
    }
    /**
     *
     */
    OnMouseOver(event) {
        // Mouse didn't actually move, so no logic needed.
        if (event.movementX === 0 && event.movementY === 0) {
            return;
        }
        /**
         *
         */
        const el = event.target || event.srcElement;
        if (el.id.length > 0 && el.id.includes(this._class)) {
            this.SetActive(Number(el.id.slice(this._class.length, el.id.length)));
        }
    }
    /**
     *
     */
    EmitSelected() {
        if (this.FindActive() > -1) {
            this.selected.emit(this._list[this.FindActive()].key);
        }
    }
    /**
     *
     */
    DropdownFocusAreaDown() {
        const scroll = this._eref.nativeElement.offsetHeight + this._eref.nativeElement.scrollTop;
        /**
         *
         */
        if ((this.GetElement(this.FindActive()).offsetTop + this.GetElement(this.FindActive()).offsetHeight) > scroll) {
            // tslint:disable-next-line:max-line-length
            this._eref.nativeElement.scrollTop = this.GetElement(this.FindActive()).offsetTop - (this._eref.nativeElement.offsetHeight - this.GetElement(this.FindActive()).offsetHeight);
        }
    }
    /**
     *
     */
    DropdownFocusAreaUp() {
        const scroll = this._eref.nativeElement.scrollTop;
        /**
         *
         */
        if (this.GetElement(this.FindActive()).offsetTop < scroll && scroll > 0) {
            this._eref.nativeElement.scrollTop = this.GetElement(this.FindActive()).offsetTop;
        }
    }
    // =======================================================================//
    // ! Bindings                                                             //
    // =======================================================================//
    /**
     *
     */
    get opened() {
        return this._open;
    }
    // =======================================================================//
    // ! Listeners                                                            //
    // =======================================================================//
    /**
     *
     */
    Close(event, force = false) {
        if (!this._open) {
            return;
        }
        const close = () => {
            this._open = false;
            /**
             * Emit NULL so listening components know what to do.
             */
            this.RemoveListeners();
            this.ClearActive();
            this.hover.emit(null);
            this.closed.emit();
            this.cdr.detectChanges();
        };
        if (force) {
            close();
            return;
        }
        if ((this._open && (!this.element.contains(event.target)))) {
            close();
        }
    }
    /**
     *
     */
    inputKeydown(event) {
        this.keyDown(event);
    }
    /**
     *
     */
    documentKeydown(event) {
        this.keyDown(event);
    }
    /**
     *
     */
    mouseoverListener(event) {
        this.OnMouseOver(event);
    }
    // =======================================================================//
    // ! Utils                                                                //
    // =======================================================================//
    /**
     *
     */
    RegisterListeners() {
        if (this.RefExists()) {
            this.input.addEventListener('keydown', this.inputKeydownBind);
        }
        if (!this.completion) {
            document.addEventListener('keydown', this.documentKeydownBind);
        }
    }
    /**
     *
     */
    RemoveListeners() {
        if (this.RefExists()) {
            this.input.removeEventListener('keydown', this.inputKeydownBind);
        }
        if (!this.completion) {
            document.removeEventListener('keydown', this.documentKeydownBind);
        }
        if (!IsMobileOrTablet()) {
            this._eref.nativeElement.removeEventListener('mouseover', this.mouseoverListenerBind);
        }
    }
    /**
     *
     */
    Open() {
        setTimeout(() => {
            if (!this._open && !this._eref.nativeElement.classList.contains('is-initial-empty')) {
                this.RegisterListeners();
                this._open = true;
                this.PrepareList();
                /**
                 *
                 */
                if (this.FindActive() < 0) {
                    this._eref.nativeElement.scrollTop = 0;
                }
                else {
                    this._eref.nativeElement.scrollTop = this.GetElement(this.FindActive()).offsetHeight * this.FindActive();
                }
                this.cdr.detectChanges();
            }
        }, 0);
    }
    /**
     *
     */
    RefExists() {
        return typeof this.input !== 'undefined';
    }
    /**
     *
     */
    FindActive() {
        return this._list.reduce((result, item, index) => {
            if (item.active) {
                result = index;
            }
            return result;
        }, -1);
    }
    /**
     *
     */
    SetActive(index) {
        if (index > this._list.length - 1 || index < 0) {
            return;
        }
        /**
         *
         */
        this.ClearActive();
        this._list[index].active = true;
        this.hover.emit(this._list[index].key);
        /**
         *
         */
        this.GetElement(index).classList.add('active');
    }
    /**
     *
     */
    GetElement(index) {
        return this._eref.nativeElement.children[index];
    }
    /**
     *
     */
    ClearActive() {
        this._list.forEach((item, index) => {
            item.active = false;
            /**
             *
             */
            this.GetElement(index).classList.remove('active');
        });
    }
    /**
     *
     */
    PrepareList() {
        this._list = Object.keys(this.list).map((key) => {
            return {
                key,
                active: this.ActiveItem(key)
            };
        });
        /**
         *
         */
        this.PrepareChildrenList();
    }
    /**
     *
     */
    ActiveItem(item) {
        return this.active !== null && item === this.active;
    }
    /**
     *
     */
    DetermineActiveClass() {
        this._list.forEach((item, index) => {
            if (typeof this.GetElement(index) === 'undefined') {
                return;
            }
            /**
             *
             */
            this.GetElement(index).classList.remove('active');
            if (item.active) {
                this.GetElement(index).classList.add('active');
            }
        });
    }
    /**
     *
     */
    PrepareChildrenList() {
        const list = this._eref.nativeElement.children;
        setTimeout(() => {
            for (let i = 0; i < list.length; i++) {
                list[i].id = this._class + i;
            }
        }, 0);
        /**
         *
         */
        this.DetermineActiveClass();
    }
    /**
     *
     */
    DeReference(object) {
        const { item } = object;
        /**
         *
         */
        return Object.assign({}, Object.assign({}, item));
    }
    /**
     *
     */
    ngOnDestroy() {
        this.RemoveListeners();
    }
}
NgDropdownDirective.ɵfac = function NgDropdownDirective_Factory(t) { return new (t || NgDropdownDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
NgDropdownDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgDropdownDirective, selectors: [["", "ngDropdown", ""]], hostVars: 2, hostBindings: function NgDropdownDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NgDropdownDirective_click_HostBindingHandler($event) { return ctx.Close($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("open", ctx.opened);
    } }, inputs: { list: "list", active: "active", input: "input", element: "element", key: "key", completion: "completion" }, outputs: { hover: "hover", selected: "selected", closed: "closed" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
NgDropdownDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
NgDropdownDirective.propDecorators = {
    list: [{ type: Input }],
    active: [{ type: Input }],
    input: [{ type: Input }],
    element: [{ type: Input }],
    key: [{ type: Input }],
    completion: [{ type: Input }],
    hover: [{ type: Output }],
    selected: [{ type: Output }],
    closed: [{ type: Output }],
    opened: [{ type: HostBinding, args: ['class.open',] }],
    Close: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgDropdownDirective, [{
        type: Directive,
        args: [{
                selector: '[ngDropdown]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { list: [{
            type: Input
        }], active: [{
            type: Input
        }], input: [{
            type: Input
        }], element: [{
            type: Input
        }], key: [{
            type: Input
        }], completion: [{
            type: Input
        }], hover: [{
            type: Output
        }], selected: [{
            type: Output
        }], closed: [{
            type: Output
        }], opened: [{
            type: HostBinding,
            args: ['class.open']
        }], 
    // =======================================================================//
    // ! Listeners                                                            //
    // =======================================================================//
    /**
     *
     */
    Close: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }] }); })();

class CompleterComponent {
    constructor(_zone, cdr) {
        this._zone = _zone;
        this.cdr = cdr;
        this.cleared = new EventEmitter();
        this.selected = new EventEmitter();
        // tslint:disable-next-line:no-output-rename
        this.noResult = new EventEmitter();
        this.group = {};
        this._change = new Subject();
        this._items = {};
        this._completer = '';
        this._highlight = '';
        this._disabled = false;
        this._DOM = {
            notFound: false,
            empty: false,
            placeholder: null,
            selected: '',
            isLoading: false
        };
        this.asyncObservable = new Subject();
    }
    /**
     *
     */
    ngOnInit() {
        this._change.pipe(debounceTime(300), distinctUntilChanged(), switchMap((value) => {
            if (this.group.async !== null) {
                return this.RunAsyncFunction(value).pipe(switchMap((res) => {
                    if (res !== null) {
                        this.ListenToAsyncFunction(res.value, res.values);
                    }
                    return of(true);
                }));
            }
            else {
                this.OnModelChange(value);
                return of(true);
            }
        }))
            .subscribe();
        this.SetItems();
    }
    /**
     * Only used when completion is off.
     */
    RegisterClick() {
        if (!this.group.completion) {
            this.SwitchDropdownState();
        }
    }
    /**
     *
     */
    DropdownArray() {
        if (this.group.completion) {
            this.SwitchDropdownState();
        }
    }
    /**
     *
     */
    SwitchDropdownState() {
        if (this.dropdown._open) {
            this.CloseDropdown();
            return;
        }
        /**
         *
         */
        this.OpenDropdown();
    }
    /**
     *
     */
    CloseDropdown() {
        this.dropdown._open = false;
        /**
         *
         */
        this._DOM.placeholder = null;
    }
    /**
     *
     */
    OpenDropdown() {
        this.dropdown.Open();
        /**
         *
         */
        this._DOM.placeholder = null;
    }
    /**
     *
     */
    SetItems() {
        this._items = this.group.value;
        this.IsInitialEmpty();
    }
    /**
     *
     */
    SelectItem(item) {
        let i;
        if (typeof item === 'string') {
            i = this._items[item];
            this._DOM.selected = item;
        }
        else {
            i = item;
            this._DOM.selected = SearchableAutoCompleteString(item.title, item.id);
        }
        this._completer = i.title;
        this._highlight = '';
        this.dropdown.Close(null, true);
        this.selected.emit({ group: { key: this.group.key }, item: i });
    }
    ListenToAsyncFunction(value, values) {
        this.group.SetNewValue(values, this.group.keys.titleKey);
        this._DOM.isLoading = false;
        this._items = this.group.value;
        this.EmptySearch(this._items, value);
        // User has typed something now, results could be shown. We need to remove the "is-initial-empty" class.
        this.IsInitialEmpty();
        this.dropdown.Open();
    }
    /**
     *
     */
    RunAsyncFunction(value) {
        this._completer = value;
        this._highlight = value;
        this._DOM.selected = null;
        if (value.length === 0) {
            this.group.InitialValue();
            this.ClearModel();
            this.dropdown.Close('', true);
            return of(null);
        }
        else if (value.length > this.group.searchLength) {
            this._DOM.isLoading = true;
            return new Observable((observer) => {
                this.group.async(value).then(values => {
                    observer.next({ value, values });
                });
            });
        }
    }
    /**
     *
     */
    OnModelChange(value) {
        this._completer = value;
        this._highlight = value;
        this._DOM.selected = null;
        if (value.length === 0) {
            this.ClearModel();
        }
        else if (value.length > this.group.searchLength) {
            this.CompareItemsAndSet(value);
        }
    }
    /**
     *
     */
    ClearModel() {
        this._DOM.selected = null;
        this._DOM.notFound = false;
        this.cleared.emit(this.group.key);
    }
    /**
     *
     */
    CompareItemsAndSet(value) {
        const obj = {};
        for (const key in this.group.value) {
            if (ComparableAutoCompleteString(key).toLowerCase().indexOf(value.toLowerCase()) > -1) {
                obj[key] = this.group.value[key];
            }
        }
        this._items = obj;
        this.EmptySearch(this._items, value);
        // User has typed something now, results could be shown. We need to remove the "is-initial-empty" class.
        this.IsInitialEmpty();
        this.dropdown.Open();
    }
    /**
     *
     */
    OnInputBlurred() {
        if (!this.HasChosenValue()) {
            /**
             * Let component know completer input has been cleared -
             * this function shows the list again, also resets children, if chosen.
             */
            this.OnModelChange('');
        }
    }
    /**
     *
     */
    OnHoverDropdownItem(item) {
        if (typeof item === 'string') {
            this._DOM.placeholder = this._items[item];
            return;
        }
        if (item == null) {
            this._DOM.placeholder = null;
            return;
        }
        this._DOM.placeholder = item;
    }
    // =======================================================================//
    // ! Utils                                                                //
    // =======================================================================//
    IsInitialEmpty() {
        if (Object.keys(this._items).length === 0 && this._completer.length === 0) {
            this._DOM.empty = true;
            return;
        }
        this._DOM.empty = false;
    }
    /**
     *
     */
    HasChosenValue() {
        return this._DOM.selected !== null;
    }
    /**
     *
     */
    EmptySearch(obj, query) {
        if (Object.keys(obj).length > 0) {
            this._DOM.notFound = false;
            return;
        }
        this._DOM.notFound = true;
        this.noResult.emit({ group: { key: this.group.key }, query: query });
    }
    /**
     *
     */
    ClearValue() {
        this._completer = '';
        this._DOM.selected = null;
        this.group.InitialValue();
        this.IsInitialEmpty();
        /**
         *
         */
        this.selected.emit({ group: { key: this.group.key }, item: null });
    }
}
CompleterComponent.ɵfac = function CompleterComponent_Factory(t) { return new (t || CompleterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CompleterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CompleterComponent, selectors: [["ng-completer"]], viewQuery: function CompleterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgDropdownDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
    } }, inputs: { group: "group" }, outputs: { cleared: "cleared", selected: "selected", noResult: "no-result" }, decls: 11, vars: 29, consts: [[1, "ng-autocomplete-dropdown", 3, "ngClass"], ["element", ""], [1, "ng-autocomplete-inputs", 3, "ngClass", "click"], ["class", "ng-autocomplete-placeholder", 4, "ngIf"], ["type", "text", "name", "completer", "autocomplete", "new-password", 1, "ng-autocomplete-input", 3, "placeholder", "ngModel", "value", "tabIndex", "ngModelChange", "focus"], ["input", ""], [1, "ng-autocomplete-dropdown-icon", 3, "ngClass", "click"], ["ngDropdown", "", 1, "ng-dropdown", 3, "list", "element", "input", "ngClass", "active", "key", "completion", "hover", "selected", "closed"], ["class", "dropdown-item no-results", 4, "ngIf"], ["class", "dropdown-item", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "ng-autocomplete-placeholder"], [4, "ngIf"], [3, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "dropdown-item", "no-results"], [1, "dropdown-item", 3, "ngClass", "click"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"]], template: function CompleterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵlistener("click", function CompleterComponent_Template_div_click_2_listener() { return ctx.RegisterClick(); });
        ɵngcc0.ɵɵtemplate(3, CompleterComponent_span_3_Template, 3, 2, "span", 3);
        ɵngcc0.ɵɵelementStart(4, "input", 4, 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function CompleterComponent_Template_input_ngModelChange_4_listener($event) { return ctx._change.next($event); })("focus", function CompleterComponent_Template_input_focus_4_listener() { return ctx.OpenDropdown(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "span", 6);
        ɵngcc0.ɵɵlistener("click", function CompleterComponent_Template_span_click_6_listener() { return ctx.DropdownArray(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵlistener("hover", function CompleterComponent_Template_div_hover_7_listener($event) { return ctx.OnHoverDropdownItem($event); })("selected", function CompleterComponent_Template_div_selected_7_listener($event) { return ctx.SelectItem($event); })("closed", function CompleterComponent_Template_div_closed_7_listener() { return ctx.OnInputBlurred(); });
        ɵngcc0.ɵɵtemplate(8, CompleterComponent_div_8_Template, 2, 1, "div", 8);
        ɵngcc0.ɵɵtemplate(9, CompleterComponent_div_9_Template, 3, 3, "div", 9);
        ɵngcc0.ɵɵpipe(10, "keys");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        const _r2 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(19, _c2, ctx.dropdown._open, ctx._DOM.isLoading, ctx.group.async !== null));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(23, _c3, !ctx.group.completion));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._DOM.placeholder);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("placeholder", ctx.group.placeholder)("ngModel", ctx._completer)("value", ctx._completer)("tabIndex", ctx._disabled ? -1 : 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(25, _c4, ctx.dropdown._open));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("list", ctx._items)("element", _r0)("input", _r2)("ngClass", ɵngcc0.ɵɵpureFunction1(27, _c5, ctx._DOM.empty))("active", ctx._DOM.selected)("key", ctx.group.key)("completion", ctx.group.completion);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._DOM.notFound && ctx.group.noResults);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(10, 17, ctx._items));
    } }, directives: function () { return [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, NgDropdownDirective, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet]; }, pipes: function () { return [KeyValuePipe, HighlightPipe]; }, styles: [".ng-autocomplete-inputs[_ngcontent-%COMP%] {\n            position: relative;\n        }\n\n        .ng-autocomplete-inputs[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]::-ms-clear, .ng-autocomplete-inputs[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]::-ms-reveal {\n            display: none;\n            width: 0;\n            height: 0;\n        }\n\n        .ng-autocomplete-inputs.completion-off[_ngcontent-%COMP%] {\n            cursor: pointer;\n        }\n\n        .ng-autocomplete-inputs.completion-off[_ngcontent-%COMP%]   input[_ngcontent-%COMP%] {\n            pointer-events: none;\n        }\n\n        .ng-autocomplete-placeholder[_ngcontent-%COMP%] {\n            pointer-events: none;\n        }\n\n        .ng-autocomplete-dropdown-icon[_ngcontent-%COMP%] {\n\n        }\n\n        .ng-autocomplete-dropdown[_ngcontent-%COMP%]   .ng-dropdown[_ngcontent-%COMP%] {\n            display: none;\n        }\n\n        .ng-autocomplete-dropdown[_ngcontent-%COMP%]   .ng-dropdown.is-empty[_ngcontent-%COMP%] {\n            display: none;\n        }\n\n        .ng-autocomplete-dropdown[_ngcontent-%COMP%]   .ng-dropdown.open[_ngcontent-%COMP%] {\n            display: block;\n        }"] });
/** @nocollapse */
CompleterComponent.ctorParameters = () => [
    { type: NgZone },
    { type: ChangeDetectorRef }
];
CompleterComponent.propDecorators = {
    dropdown: [{ type: ViewChild, args: [NgDropdownDirective, { static: true },] }],
    cleared: [{ type: Output }],
    selected: [{ type: Output }],
    noResult: [{ type: Output, args: ['no-result',] }],
    group: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CompleterComponent, [{
        type: Component,
        args: [{
                selector: 'ng-completer',
                template: `
        <div #element class="ng-autocomplete-dropdown"
             [ngClass]="{'open': dropdown._open, 'is-loading': _DOM.isLoading, 'is-async': group.async !== null}">

            <!--GROUP: {{group.key}}-->

            <div class="ng-autocomplete-inputs" (click)="RegisterClick()"
                 [ngClass]="{'completion-off': !group.completion}">
                <span class="ng-autocomplete-placeholder"
                      *ngIf="_DOM.placeholder">
                  <ng-container *ngIf="group.placeholderValue">
                      <ng-template *ngTemplateOutlet="group.placeholderValue; context: {$implicit: _DOM.placeholder}"></ng-template>
                  </ng-container>
                  <ng-template [ngIf]="!group.placeholderValue">
                      {{_DOM.placeholder.title}}
                  </ng-template>
                </span>
                <input #input type="text" [placeholder]="group.placeholder" name="completer" [ngModel]="_completer"
                       (ngModelChange)="_change.next($event);"
                       [value]="_completer"
                       [tabIndex]="_disabled ? -1 : 0"
                       autocomplete="new-password"
                       (focus)="OpenDropdown()" class="ng-autocomplete-input">

                <span [ngClass]="{'open': dropdown._open}" class="ng-autocomplete-dropdown-icon"
                      (click)="DropdownArray()"></span>
            </div>

            <div class="ng-dropdown" ngDropdown [list]="_items" [element]="element" [input]="input"
                 [ngClass]="{'is-initial-empty': _DOM.empty}"
                 [active]="_DOM.selected" [key]="group.key"
                 [completion]="group.completion"
                 (hover)="OnHoverDropdownItem($event)"
                 (selected)="SelectItem($event)"
                 (closed)="OnInputBlurred()"
            >
                <div *ngIf="_DOM.notFound && group.noResults" class="dropdown-item no-results">
                    <ng-container *ngIf="group.noResults">
                        <ng-template *ngTemplateOutlet="group.noResults; context: {$implicit: _completer}"></ng-template>
                    </ng-container>
                </div>

                <div class="dropdown-item" *ngFor="let item of _items | keys; let i = index"
                     (click)="SelectItem(_items[item])" [ngClass]="_items[item].className">
                    <ng-container *ngIf="group.dropdownValue">
                        <ng-template
                            *ngTemplateOutlet="group.dropdownValue; context: {$implicit: _items[item], highlight: _items[item].title | highlight:_highlight}"></ng-template>
                    </ng-container>

                    <div *ngIf="!group.dropdownValue" [innerHTML]="_items[item].title | highlight:_highlight"></div>
                </div>
            </div>
        </div>`,
                styles: [`
        .ng-autocomplete-inputs {
            position: relative;
        }

        .ng-autocomplete-inputs input[type=text]::-ms-clear,
        .ng-autocomplete-inputs input[type=text]::-ms-reveal {
            display: none;
            width: 0;
            height: 0;
        }

        .ng-autocomplete-inputs.completion-off {
            cursor: pointer;
        }

        .ng-autocomplete-inputs.completion-off input {
            pointer-events: none;
        }

        .ng-autocomplete-placeholder {
            pointer-events: none;
        }

        .ng-autocomplete-dropdown-icon {

        }

        .ng-autocomplete-dropdown .ng-dropdown {
            display: none;
        }

        .ng-autocomplete-dropdown .ng-dropdown.is-empty {
            display: none;
        }

        .ng-autocomplete-dropdown .ng-dropdown.open {
            display: block;
        }
    `]
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }]; }, { cleared: [{
            type: Output
        }], selected: [{
            type: Output
        }], noResult: [{
            type: Output,
            args: ['no-result']
        }], group: [{
            type: Input
        }], dropdown: [{
            type: ViewChild,
            args: [NgDropdownDirective, { static: true }]
        }] }); })();

class NgAutoCompleteComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.selected = new EventEmitter();
        // tslint:disable-next-line:no-output-rename
        this.noResult = new EventEmitter();
        this.group = [];
        this.key = '';
        this.classes = [];
        this._viewHasBeenInit = false;
        this._viewInitSubject = new Subject();
    }
    // =======================================================================//
    // ! Static (utils)                                                       //
    // =======================================================================//
    /**
     *
     */
    static FindCompleter(key, list) {
        const completer = list.filter((c) => {
            return key === c.key;
        });
        if (typeof completer[0] !== 'undefined') {
            return completer[0];
        }
        return null;
    }
    /**
     *
     */
    ngOnInit() {
    }
    /**
     *
     */
    ngAfterViewChecked() {
        if (!this._viewHasBeenInit) {
            const el = this.init.nativeElement.querySelector('.after-view-init');
            if (window.getComputedStyle(el).length > 0) {
                this._viewHasBeenInit = true;
                this._viewInitSubject.next(true);
            }
        }
    }
    /**
     *
     */
    ListenToSelected(selected) {
        this.selected.emit(selected);
        /**
         *
         */
        this.SetChildren(selected);
    }
    /**
     *
     */
    NoResult(group) {
        this.noResult.emit(group);
    }
    /**
     *
     */
    InputCleared(key) {
        this.group.forEach((group) => {
            if (group.key === key || group.parent === key) {
                this.ResetInput(group.key);
            }
        });
        /**
         * Items may have changed, need to te re-set list in completer components.
         */
        this.TriggerChange();
    }
    /**
     *
     */
    SetChildren(selected) {
        this.group.forEach((item) => {
            if (item.parent === selected.group.key) {
                this.ResetInput(item.key);
                /**
                 *
                 */
                if (selected.item !== null && typeof selected.item.children !== 'undefined') {
                    item.SetNewValue(selected.item.children, selected.group.keys.titleKey);
                }
            }
        });
        /**
         * Items may have changed, need to te re-set list in completer components.
         */
        this.TriggerChange();
    }
    /**
     *
     */
    TriggerChange() {
        this.completers.forEach((completer) => {
            completer.SetItems();
        });
    }
    // =======================================================================//
    // ! Utils                                                                //
    // =======================================================================//
    /**
     *
     */
    GetInput(key) {
        return this.completers.reduce((result, completer) => {
            if (completer.group.key === key) {
                result = completer;
            }
            return result;
        }, {});
    }
    /**
     *
     */
    SubscribeInput(key, f) {
        if (this._viewHasBeenInit) {
            const completer = this.GetInput(key);
            /**
             *
             */
            f(completer);
            return;
        }
        this._viewInitSubject.subscribe((_bool) => {
            const completer = this.GetInput(key);
            setTimeout(() => {
                f(completer);
            });
            this._viewInitSubject.unsubscribe();
        });
    }
    /**
     *
     */
    ResetInput(key) {
        this.SubscribeInput(key, (completer) => {
            completer.ClearValue();
        });
    }
    /**
     *
     */
    SetValues(key, values) {
        this.SubscribeInput(key, (completer) => {
            completer.group.SetValues(values);
            /**
             * Items may have changed, need to te re-set list in completer components.
             */
            this.TriggerChange();
        });
    }
    /**
     *
     */
    SetTemplate(key, type, template) {
        this.SubscribeInput(key, (completer) => {
            completer.group[type] = template;
            /**
             * Items may have changed, need to te re-set list in completer components.
             */
            this.TriggerChange();
        });
    }
    /**
     *
     */
    SetAsync(key, promise) {
        this.SubscribeInput(key, (completer) => {
            completer.group.async = promise;
            /**
             * Items may have changed, need to te re-set list in completer components.
             */
            this.TriggerChange();
        });
    }
    /**
     *
     */
    SetEnable(key) {
        this.SubscribeInput(key, (completer) => {
            completer._disabled = false;
            /**
             * Items may have changed, need to te re-set list in completer components.
             */
            this.TriggerChange();
        });
    }
    /**
     *
     */
    SetDisable(key) {
        this.SubscribeInput(key, (completer) => {
            completer._disabled = true;
            /**
             * Items may have changed, need to te re-set list in completer components.
             */
            this.TriggerChange();
        });
    }
    /**
     *
     */
    SelectItem(key, id) {
        this.SubscribeInput(key, (completer) => {
            Object.keys(completer._items).forEach((k) => {
                const f = `_id_${String(id)}`;
                const c = k.substring(k.indexOf(f), k.length);
                if (f === c) {
                    completer.SelectItem(completer._items[k]);
                }
            });
        });
    }
    /**
     *
     */
    RemovableValues(key, ids) {
        this.SubscribeInput(key, (completer) => {
            completer.group.Removables(ReturnStringArrayByID(ids));
            /**
             * Items may have changed, need to te re-set list in completer components.
             */
            this.TriggerChange();
        });
    }
    /**
     *
     */
    ResetInputs() {
        this.group.forEach((item) => {
            this.ResetInput(item.key);
        });
    }
}
NgAutoCompleteComponent.ɵfac = function NgAutoCompleteComponent_Factory(t) { return new (t || NgAutoCompleteComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
NgAutoCompleteComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgAutoCompleteComponent, selectors: [["ng-auto-complete"]], viewQuery: function NgAutoCompleteComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 7);
        ɵngcc0.ɵɵviewQuery(CompleterComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.init = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.completers = _t);
    } }, inputs: { group: "group", key: "key", classes: "classes" }, outputs: { selected: "selected", noResult: "no-result" }, decls: 4, vars: 1, consts: [[2, "display", "none"], ["init", ""], [1, "after-view-init"], [3, "ngClass", "group", "cleared", "no-result", "selected", 4, "ngFor", "ngForOf"], [3, "ngClass", "group", "cleared", "no-result", "selected"]], template: function NgAutoCompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelement(2, "span", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, NgAutoCompleteComponent_ng_completer_3_Template, 1, 2, "ng-completer", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.group);
    } }, directives: [ɵngcc1.NgForOf, CompleterComponent, ɵngcc1.NgClass], encapsulation: 2 });
/** @nocollapse */
NgAutoCompleteComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
NgAutoCompleteComponent.propDecorators = {
    completers: [{ type: ViewChildren, args: [CompleterComponent,] }],
    init: [{ type: ViewChild, args: ['init', { static: true },] }],
    selected: [{ type: Output }],
    noResult: [{ type: Output, args: ['no-result',] }],
    group: [{ type: Input }],
    key: [{ type: Input }],
    classes: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgAutoCompleteComponent, [{
        type: Component,
        args: [{
                selector: 'ng-auto-complete',
                template: `
        <div #init style="display: none;"><span class="after-view-init"></span></div>
        <ng-completer [ngClass]="classes" *ngFor="let item of group" (cleared)="InputCleared($event)"
                      (no-result)="NoResult($event)"
                      (selected)="ListenToSelected($event)"
                      [group]="item"></ng-completer>
    `
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { selected: [{
            type: Output
        }], noResult: [{
            type: Output,
            args: ['no-result']
        }], group: [{
            type: Input
        }], key: [{
            type: Input
        }], classes: [{
            type: Input
        }], completers: [{
            type: ViewChildren,
            args: [CompleterComponent]
        }], init: [{
            type: ViewChild,
            args: ['init', { static: true }]
        }] }); })();

class HighlightPipe {
    transform(text, search) {
        if (search.length > 0) {
            return this.Strip(text).replace(new RegExp(`${this.EscapeMatch(search)}`, 'gi'), (match) => {
                return `<span class="dropdown-item-highlight">${match}</span>`;
            });
        }
        else {
            return text;
        }
    }
    EscapeMatch(match) {
        const entityMap = {
            '&': '\\&',
            '<': '\\<',
            '>': '\\>',
            '/': '\\/',
            '=': '\\=',
            '+': '\\+',
            '-': '\\-',
            '#': '\\#',
            '!': '\\!',
            '@': '\\@',
            '$': '\\$',
            '%': '\\%',
            '^': '\\^',
            '*': '\\*',
            '(': '\\(',
            ')': '\\)',
        };
        return String(match).replace(/[&<>"'`=+\/]/g, function (s) {
            return entityMap[s];
        });
    }
    Strip(str_in = '') {
        return str_in.replace(/<[^>]*>/g, '');
    }
}
HighlightPipe.ɵfac = function HighlightPipe_Factory(t) { return new (t || HighlightPipe)(); };
HighlightPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "highlight", type: HighlightPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HighlightPipe, [{
        type: Pipe,
        args: [{
                name: 'highlight'
            }]
    }], null, null); })();

class KeyValuePipe {
    transform(value, args) {
        let keys = [];
        for (let key in value) {
            if (value.hasOwnProperty(key)) {
                keys.push(key);
            }
        }
        return keys;
    }
}
KeyValuePipe.ɵfac = function KeyValuePipe_Factory(t) { return new (t || KeyValuePipe)(); };
KeyValuePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "keys", type: KeyValuePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KeyValuePipe, [{
        type: Pipe,
        args: [{
                name: 'keys'
            }]
    }], null, null); })();

class PipeModule {
    static forRoot() {
        return {
            ngModule: PipeModule,
            providers: [],
        };
    }
}
PipeModule.ɵfac = function PipeModule_Factory(t) { return new (t || PipeModule)(); };
PipeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PipeModule });
PipeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PipeModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [HighlightPipe, KeyValuePipe],
                exports: [HighlightPipe, KeyValuePipe]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PipeModule, { declarations: [HighlightPipe, KeyValuePipe], exports: [HighlightPipe, KeyValuePipe] }); })();

class NgAutoCompleteModule {
}
NgAutoCompleteModule.ɵfac = function NgAutoCompleteModule_Factory(t) { return new (t || NgAutoCompleteModule)(); };
NgAutoCompleteModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgAutoCompleteModule });
NgAutoCompleteModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            PipeModule.forRoot()
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgAutoCompleteModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    PipeModule.forRoot()
                ],
                exports: [
                    NgAutoCompleteComponent,
                    CompleterComponent,
                ],
                declarations: [
                    NgAutoCompleteComponent,
                    CompleterComponent,
                    NgDropdownDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgAutoCompleteModule, { declarations: function () { return [NgAutoCompleteComponent, CompleterComponent, NgDropdownDirective]; }, imports: function () { return [CommonModule,
        FormsModule, PipeModule]; }, exports: function () { return [NgAutoCompleteComponent, CompleterComponent]; } }); })();

/*
 * Public API Surface of ng-auto-complete
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AutocompleteGroup, AutocompleteItem, ComparableAutoCompleteString, CompleterComponent, CreateNewAutocompleteGroup, FilterRemovals, HighlightPipe, IsMobileOrTablet, KeyValuePipe, NgAutoCompleteComponent, NgAutoCompleteModule, NotUsedKey, PipeModule, ReturnStringArrayByID, SearchableAutoCompleteItems, SearchableAutoCompleteString, TransformToAutocompleteItem, NgDropdownDirective as ɵa };

